<script>
import posthog from 'posthog-js';
export default {
    name: "Inactive",
    head() {
        return {
            title: 'Produto não encontrado',
        }
    },
    mounted(){
        posthog.capture('404')
    }
}
</script>
<template>
    <div class="flex items-center justify-center h-screen bg-slate-200 text-lg font-bold font-sans">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="w-6 h-6 fill-orange-400">
            <path stroke-linecap="round" stroke-linejoin="round"
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
        Produto não encontrado
    </div>
</template>
<style scoped>
    @import url('@/assets/css/tailwind.css');
    body{margin:0px}
    html {
        font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI',
        Roboto, 'Helvetica Neue', Arial, sans-serif;
        font-size: 16px;
        word-spacing: 1px;
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        box-sizing: border-box;
        -ms-text-size-adjust: 100%;
        -webkit-text-size-adjust: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        box-sizing: border-box;
        --scroll-behavior: smooth;
        scroll-behavior: smooth;
    }
</style>
